<template>
  <el-dialog :visible.sync="visibleSync"
             :title="dialogTitle"
             width="70%"
             top="2vh"
             :append-to-body="true"
             destroy-on-close
             custom-class="project-node-view-dialog"
             @close="handleViewClose">
    <!-- 动态组件：根据 nodeKey 渲染不同组件 -->
    <component :is="currentViewComponent"
               v-if="currentViewComponent"
               :project-id="projectId"
               :fullNode="fullNode"/>

    <!-- 无对应组件时的默认展示 -->
    <div v-else
         class="no-view-component">
      <i class="el-icon-info"></i>
      <p>该节点暂无查看详情组件</p>
      <p class="node-key">key: {{ nodeKey }}</p>
    </div>
  </el-dialog>
</template>

<script>
import projectMixins from '@views/project/project.mixins'
// 导入各节点的查看组件
import UploadCustomerListView from '@views/project/node-views/UploadCustomerListView.vue'
import KickoffMeetingView from '@views/project/node-views/KickoffMeetingView.vue'
import UploadCleanedFilesView from '@views/project/node-views/UploadCleanedFilesView.vue'
import ProgressShareMeetingView from '@views/project/node-views/ProgressShareMeetingView.vue'
import UploadProjectReportView from '@views/project/node-views/UploadProjectReportView.vue'
import ReviewMeetingView from '@views/project/node-views/ReviewMeetingView.vue'
import BoHeadEvaluationView from '@views/project/node-views/BoHeadEvaluationView.vue'
import TaskOfflineView from '@views/project/node-views/TaskOfflineView.vue'
import TaskOnlineView from '@views/project/node-views/TaskOnlineView.vue'
import ProjectIssueInvoiceView from '@views/project/node-views/ProjectIssueInvoiceView.vue'
import PaymentReceiveView from '@views/project/node-views/PaymentReceiveView.vue'
import ProjectCostConfirmView from '@views/project/node-views/ProjectCostConfirmView.vue'

export default {
  mixins: [projectMixins],
  components: {
    UploadCustomerListView,
    KickoffMeetingView,
    UploadCleanedFilesView,
    ProgressShareMeetingView,
    UploadProjectReportView,
    ReviewMeetingView,
    BoHeadEvaluationView,
    TaskOfflineView,
    TaskOnlineView,
    ProjectIssueInvoiceView,
    PaymentReceiveView,
    ProjectCostConfirmView,
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: [String, Number],
      default: ''
    },
    fullNode: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      visibleSync: false
    }
  },
  computed: {
    // 节点 key
    nodeKey () {
      return this.fullNode.key || ''
    },
    // 当前应渲染的组件
    currentViewComponent () {
      if (!this.nodeKey || !this.projectProgressNodeMap) return null
      return this.projectProgressNodeMap[this.nodeKey].nodeViewComponent || null
    },
    // 弹窗标题
    dialogTitle () {
      const nodeName = this.fullNode.name || '节点详情'
      return `${nodeName} - 查看`
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.visibleSync = val
      },
      immediate: true
    },
    visibleSync (val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    handleViewClose () {
      this.visibleSync = false
      this.$emit('refreshDetail')
    }
  }
}
</script>

<style lang="scss">
.project-node-view-dialog {
  min-height: 80vh !important;
  max-height: 95vh !important;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

  .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid #f1f5f9;
    background: #f8fafc;
    flex-shrink: 0;
  }

  .el-dialog__body {
    padding: 24px;
    flex: 1;
    overflow-y: auto;
  }
}
</style>

<style lang="scss"
       scoped>
.no-view-component {
  text-align: center;
  padding: 60px 20px;
  color: #94a3b8;

  i {
    font-size: 48px;
    color: #cbd5e1;
    margin-bottom: 16px;
  }

  p {
    font-size: 14px;
    margin: 8px 0;
  }

  .node-key {
    font-size: 12px;
    color: #64748b;
    font-family: monospace;
    background: #f1f5f9;
    padding: 4px 12px;
    border-radius: 4px;
    display: inline-block;
    margin-top: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/pages/ProjectNodeView.vue